(() => {
  const app = window.TWLuxuryHome;
  if (!app) return;

  app.register('[data-twlh-system]', (root, api) => {
    const tabs = [...root.querySelectorAll('[data-system-tab]')];
    const panels = [...root.querySelectorAll('[data-system-panel]')];
    const markerNumber = root.querySelector('[data-system-marker-number]');
    const markerLabel = root.querySelector('[data-system-marker-label]');
    const fineHover = matchMedia('(hover: hover) and (pointer: fine)');
    const controller = new AbortController();
    let active = -1;
    let hoverTimer = 0;
    let visibilityMode = null;

    panels.forEach(api.track);

    const select = (index, focus = false) => {
      const next = Math.max(0, Math.min(tabs.length - 1, index));
      if (next === active && !focus) return;
      active = next;
      visibilityMode = null;
      tabs.forEach((tab, itemIndex) => {
        const selected = itemIndex === active;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel, itemIndex) => {
        const selected = itemIndex === active;
        panel.classList.toggle('is-active', selected);
        panel.setAttribute('aria-hidden', String(!selected && !api.compact.matches));
      });
      if (markerNumber) markerNumber.textContent = tabs[active]?.querySelector('b')?.textContent || '';
      if (markerLabel) markerLabel.textContent = tabs[active]?.querySelector('span')?.textContent || '';
      if (focus) tabs[active]?.focus();
    };

    const queueHoverSelect = (index) => {
      window.clearTimeout(hoverTimer);
      if (!fineHover.matches || api.compact.matches) return;
      hoverTimer = window.setTimeout(() => select(index), 140);
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        window.clearTimeout(hoverTimer);
        select(index);
      }, { signal: controller.signal });

      tab.addEventListener('mouseenter', () => queueHoverSelect(index), { signal: controller.signal });
      tab.addEventListener('mouseleave', () => window.clearTimeout(hoverTimer), { signal: controller.signal });

      tab.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        window.clearTimeout(hoverTimer);
        if (event.key === 'Home') select(0, true);
        else if (event.key === 'End') select(tabs.length - 1, true);
        else select(active + (event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1), true);
      }, { signal: controller.signal });
    });

    document.addEventListener('shopify:block:select', (event) => {
      const tab = event.target?.closest?.('[data-system-tab]');
      if (!tab || !root.contains(tab)) return;
      const index = Number(tab.dataset.systemTab);
      if (!Number.isInteger(index)) return;
      select(index);
      api.invalidate();
    }, { signal: controller.signal });

    select(0);

    return {
      update({ reduced }) {
        const staticMode = reduced || root.dataset.motion === 'false';
        if (staticMode) {
          if (visibilityMode !== 'all') {
            panels.forEach((panel) => panel.setAttribute('aria-hidden', 'false'));
            visibilityMode = 'all';
          }
          return;
        }

        if (!api.compact.matches) {
          const mode = `single:${active}`;
          if (visibilityMode !== mode) {
            panels.forEach((panel, index) => panel.setAttribute('aria-hidden', String(index !== active)));
            visibilityMode = mode;
          }
          return;
        }

        const readingLine = Math.min(window.innerHeight * .5, window.innerWidth + 32);
        const focus = (window.scrollY || 0) + readingLine;
        let candidate = active;
        const centers = panels.map((panel) => {
          const metric = api.metrics.get(panel);
          return metric ? metric.top + metric.height * .5 : Number.POSITIVE_INFINITY;
        });

        /* Unterschiedliche Eintritts- und Rückkehrgrenzen stabilisieren den
           mobilen Marker, ohne seine bestehende Leselinien-Choreografie zu ändern. */
        while (candidate < panels.length - 1 && centers[candidate + 1] <= focus - 18) candidate += 1;
        while (candidate > 0 && centers[candidate] > focus + 34) candidate -= 1;

        if (candidate !== active) select(candidate);
        if (visibilityMode !== 'all') {
          panels.forEach((panel) => panel.setAttribute('aria-hidden', 'false'));
          visibilityMode = 'all';
        }
      },
      destroy() {
        window.clearTimeout(hoverTimer);
        controller.abort();
      }
    };
  });
})();
